/*
 lib dependencies
 - jQuery
 - lmnmodal
 - handlebars (template in footer)
*/

;var lmnDialog = (function($)
{
	//module vars
	var _template = '#jstmpl_dialog';

	//module functions
	function alert(p)
	{
		if (typeof p == 'string') p = { body: p };

		p = jQuery.extend({
			title: '',
			body: '',
			label: 'Ok',
			classes: 'btn'
		}, p);

		dialog({
			title: p.title,
			body: p.body,
			buttons: [
				{ type: 'button', label: p.label, classes: p.classes, action: lmnModal.close }
			],
			popup_class: "popup--alert"
		})
	}

	function confirm(p)
	{
		p = jQuery.extend({
			title: '',
			body: '',
			labels: {
				confirm: 'Ok',
				cancel: 'Annuleren'
			},
			classes: {
				confirm: 'btn',
				cancel: 'btn-alt'
			},
			on_confirm: lmnModal.close,
			on_cancel: lmnModal.close
		}, p);

		dialog({
			title: p.title,
			body: p.body,
			buttons: [
				{ type: 'button', label: p.labels.confirm, classes: p.classes.confirm, action: p.on_confirm },
				{ type: 'link', label: p.labels.cancel, classes: p.classes.cancel, action: p.on_cancel }
			],
			popup_class: "popup--confirm"
		})
	}

	function dialog(p)
	{
		var p = jQuery.extend({
			title: '',
			body: '',
			buttons: [
				{ type: 'button', label: 'Ok', classes: 'btn', action: lmnModal.close }
			],
			on_close: function() {},
			popup_class: ""
		}, p);

		if (typeof _template == 'string')
		{
			//first run, compile template
			var source = $(_template).html();
			_template = Handlebars.compile(source);
		}
		lmnModal.open(
		{
			html: _template(p),
			events:
			{
				afteropen: function($modal)
				{
					//bind button actions
					for (var i=0; i<p.buttons.length; i++)
					{
						if (p.buttons[i].action != undefined)
						{
							$('#lmndialog_btn_'+i).data('lmndialog_action', p.buttons[i].action);
							$('#lmndialog_btn_'+i).on('click', function(e) { e.preventDefault(); $(this).data('lmndialog_action')(); });
						}
					}
				},
				afterclose: p.on_close
			}
		});
	}


	//util
	/*function _isHTML(str)
	{
	    var tempdoc = new DOMParser().parseFromString(str, "text/html");
	    return [].slice.call(tempdoc.body.childNodes).some(function(node)
		{
			return node.nodeType === 1
		});
	}*/

	//reveal public vars and functions
	return {
		//vars

		//functions
		alert: alert,
		confirm: confirm,
		dialog: dialog
	}

})(jQuery);
